import { useQuery } from '@tanstack/react-query';
import { searchQuestionnaires } from '../../apis/questionnaires/requests';

export const useSearchQuestionnaires = (searchTerm: string) => {
  const { data: questionnairesResponse, isFetched: isLoaded, refetch } = useQuery({
    queryKey: ['questionnaires', 'search', searchTerm],
    queryFn: () => searchQuestionnaires(searchTerm),
    meta: { errorMessage: 'Failed to load questionnaires list' },
    enabled: Boolean(searchTerm)
  });

  const total = questionnairesResponse?.pagination?.total ?? 0;

  return {
    questionnaires: questionnairesResponse?.data || [],
    isLoaded,
    total,
    refetch
  };
};
